/* eslint-disable */
import React, {useState} from "react";
import {createUseStyles, useTheme} from "react-jss";

import FormDev from "../../../../../artibulles-cis/FormDev/FormDev";
import _ from "lodash";
import FormSubmitButtons from "../../../../../artibulles-cis/FormSubmitButtons/FormSubmitButtons";

/************** NEW COMPONENTS **************/

import FormCompontent from "../../../../../artibulles-cis/FormComponent/FormCompontent";
import CheckBox from "../../../../../artibulles-cis/CheckBox/CheckBox";

/************** NEW COMPONENTS **************/

const styles = createUseStyles((theme) => ({
    FormWrapper: {
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        // border: "1px solid grey",
        padding: "10px",
        // height: "100%",
        color: "black",
    },
    FormTitle_Wrapper: {
        display: "flex",
        margin: "0 auto",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "500px",
        boxSizing: "border-box",
    },
    FormTitle_Box: {
        display: "flex",
        margin: "0 auto",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "500px",
        height: "60px",
        border: "1px solid grey",
        borderRadius: "3px",
        boxSizing: "border-box",
        padding: "5px 10px",
    },
    FormTitle_Logo_Wrapper: {
        flex: "0 0 50px",
        boxSizing: "border-box",
        borderRadius: "3px",
        padding: "4px",
        border: "1px solid grey",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    FormTitle_Logo: {
        width: "43px",
        height: "auto",
    },
    FormTitle_Title_Wrapper: {
        flex: "1 1 auto",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "flex-start",
        padding: "0px 0px 0px 10px",
        alignItems: "center",
    },
    FormTitle_Title: {
        fontFamily: "Roboto",
        fontWeight: "400",
        fontSize: "22px",
        margin: "0px",
    },

    FormSection: {
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        borderBottom: "2px solid grey",
        padding: "10px",
        marginBottom: "20px",
    },
    FormSectionTitle: {
        margin: "0px 0px 10px 0px",
    },
    FormSectionContent: {
        display: "flex",
        flexDirection: "column",
        padding: "0px 0px 0px 5px",
    },
    FormFieldCenteredMaxWidth: {
        flex: "0 1 600px",
    },
    FormMultilineFlex: {
        display: "flex",
        flexDirection: "row",
        margin: "4px 0px 4px 0px",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
    },
    FormFieldMultiLineMaxWidth: {
        flex: "0 1 300px",
        margin: "0px 0px 0px 0px",
    },
    FormFieldMultiLineLeft: {
        flex: "0 1 300px",
    },
    FormField: {
        flex: "0 1 600px",
        margin: "5px 10px 5px 10px",
    },
    FormFieldCheckBoxAligned: {
        flex: "0 1 600px",
        margin: "0px 10px 0px 10px",
    },

    FormFieldSwitchBoxAligned: {
        flex: "0 1 600px",
        margin: "0px 10px 0px 10px",
    },
    ButtonBar: {
        display: "flex",
        flexWrap: "wrap",
        flex: "1 1 700px",
        justifyContent: "flex-start",
        alignItems: "center",
        boxSizing: "border-box",
        position: "relative",
        padding: "8px 20px 8px 20px",
    },
    tooltipP: {
        fontSize: "14px",
        padding: "0px",
    },
    FormLeft: {
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        position: "relative",
    },
    FormErrorMainMessage: {
        display: "flex",
        padding: "5px",
        boxSizing: "border-box",
        color: "orange",
    },
}));

const Component = React.memo(function Component(props) {
    const {
        DevMode = true, //used to check the form content wihtout sending it to the server
        FormData, //Load the Data into the form FormData = {SelectOptions:{option1 : [value :"", label :""]},InitiaFormValues : {}}
        OnSubmitExternal, //A function that hanldes the sumbission const OnSubmitExternal = FullSubmission=>{console.log(FullSubmission)}
        DisableToolTip = false, //To Enable or disable the Tooltip if required
        ButtonSaveAsDraft,
        ButtonSaveAndQuit,
        ButtonQuitNoSave,
        ButtonDelete,
        ButtonPublish,
        ButtonReset,
        ButtonNext,
        ButtonPrevious,
        OpenInViewMode,
        SwitchEditMode,
    } = props;

    const theme = useTheme();
    const classes = styles({...props, theme});

    /**************** REQUIRED STATE (DONT NEED TO BE UPDATED NORMALLY) *****************/
    const [FormDataInitReady, setFormDataInitReady] = useState(false); //PREVENT RENDERING THE FORM WHEN DATA IS NOT READY YET
    const [InitialFormValues, setInitialFormValues] = React.useState({}); //INITIAL FORM VALUES
    const [FormValues, setFormValues] = React.useState({}); //FINAL FORM VALUES
    const [FieldOptions, setFieldOptions] = React.useState({}); //FORM OPTIONS FOR SELECT
    const [NewFieldOptions, setNewFieldOptions] = React.useState({}); //Used for CreatableSelect to pass back to the server
    const [FieldSubOptionsFull, setFieldSubOptionsFull] = React.useState({}); //FORM SUBOPTIONS FOR SELECT
    const [FilesUploaders, setFilesUploaders] = React.useState({});
    const [Invalid, setInvalid] = useState(false); //Form has invalid fields
    const [Pristine, setPristine] = useState(true); //Form has been edited by the user -> Pristie === false
    const [PristineDetails, setPristineDetails] = useState({});
    const [FormViewMode, setFormViewMode] = useState();
    const [InitialFormErrors, setInitialFormErrors] = useState({});
    const [FormErrors, setFormErrors] = useState({}); //HNDLING FORM ERRORS
    const [InitialFormErrorMain, setInitialFormErrorMain] = useState(); //HNDLING FORM ERROR GLOBAL MESSAGE
    const [FormErrorMain, setFormErrorMain] = useState(); //HNDLING FORM ERROR GLOBAL MESSAGE

    /**************** REQUIRED STATE (DONT NEED TO BE UPDATED NORMALLY) *****************/
    /**************** VIEW OR EDIT MODE CONTROL *****************/
    React.useEffect(() => {
        if (OpenInViewMode === true) {
            if (SwitchEditMode === "EditButton") {
                setFormViewMode("EditButton");
            }
            if (SwitchEditMode === "FieldClick") {
                setFormViewMode("FieldClick");
            } else {
                setFormViewMode("View");
            }
        } else {
            setFormViewMode("Edit");
        }
    }, [OpenInViewMode, SwitchEditMode]);
    /**************** VIEW OR EDIT MODE CONTROL *****************/
    /**************** INITIAL FORM VALUES AND OPTIONS *****************/
    React.useEffect(() => {
        if (FormData) {
            if (FormData.SelectOptions) {
                //Cloning the object ????Why
                let LoadData = JSON.parse(JSON.stringify(FormData.SelectOptions));
                setFieldOptions(LoadData);
            }
            if (FormData.InitiaFormValues) {
                setInitialFormValues(FormData.InitiaFormValues);
                setFormValues(FormData.InitiaFormValues);
            }
            if (FormData.SubOptionsFull) {
                setFieldSubOptionsFull(FormData.SubOptionsFull);
            }
            if (FormData.FilesUploaders) {
                //Cloning the object
                let filesinit = JSON.parse(JSON.stringify(FormData.FilesUploaders));
                setFilesUploaders(filesinit);
            }
            if (FormData.InitiaFormErrors) {
                setInitialFormErrors(FormData.InitiaFormErrors);
                setFormErrors(FormData.InitiaFormErrors);
            }
            if (FormData.InitialFormErrorMain) {
                setInitialFormErrorMain(FormData.InitialFormErrorMain);
                setFormErrorMain(FormData.InitialFormErrorMain);
                //Set the form to invalid
                setInvalid(true);
            }
            setFormDataInitReady(true);
        }
    }, [FormData]);

    /**************** INITIAL FORM VALUES AND OPTIONS *****************/

    /**************** HANDLING SELECT CHANGE - INCLUDING SUB-SELECT *****************/
    const handleSelectChange = (field, SelectedDetails) => {
        //Hanlding the select change
        //Checking Pristine

        let FieldPristine = SelectedDetails.Pristine;
        let SelectedValues = SelectedDetails.Value;

        /************* DONT MODIFY THIS LOGIC OR THE PRISTINE AND INVALID WILL BE LOST *****************/
        var FinalPristine = true;

        //Checking Pristine using the FieldResponse
        let PristineKeys = _.keys(PristineDetails);
        let UpdatedPristineDetails = PristineDetails;

        if (PristineKeys && PristineKeys.length > 0) {
            //Going through all the pristine fields to check if one of them is false
            var CurrentFieldHandled = false;
            PristineKeys.forEach((key) => {
                if (key === field) {
                    CurrentFieldHandled = true;
                    //Update the pristine value
                    UpdatedPristineDetails[field] = FieldPristine;
                    if (FieldPristine === false) {
                        FinalPristine = false;
                    }
                } else {
                    //just checking if false;
                    if (UpdatedPristineDetails[key] === false) {
                        FinalPristine = false;
                    }
                }
            });
            if (CurrentFieldHandled === false) {
                //The key wasn't there so we need to add it
                if (FieldPristine === false) {
                    UpdatedPristineDetails = {...UpdatedPristineDetails, ...{[field]: false}};
                    FinalPristine = false;
                }
            }
        } else {
            //First field to be touched
            if (FieldPristine === false) {
                UpdatedPristineDetails = {...UpdatedPristineDetails, ...{[field]: false}};
                FinalPristine = false;
            }
        }
        setPristineDetails(UpdatedPristineDetails);
        setPristine(FinalPristine);
        var UpdatedFormValues = {...FormValues, ...{[field]: SelectedValues}};
        /************* DONT MODIFY THIS LOGIC OR THE PRISTINE AND INVALID WILL BE LOST *****************/

        /************* IF NO CONDITIONAL SELECT USE THIS *****************/
        setFormValues(UpdatedFormValues);
        /************* IF NO CONDITIONAL SELECT USE THIS *****************/

        /************* CONDITIONAL SELECT *****************/
        //To prevent having to deal with different server configuration, the logic to implement here must be tailored to your needs

        /*Option 1 :
         *Updating the options of a subfield based on the select value ->
         *If you use this, don't forget to specify that the conditional field is disabled if the parentField is empty or null
         */

        if (field === "ref_company") {
            //We update the Options of the ConditionalSelect2
            let SubOptions = [];

            FieldSubOptionsFull.ref_company.forEach((elem) => {
                if (elem.ref_company === SelectedValues) {
                    let newsub = {value: elem.id, label: elem.program_name};
                    SubOptions.push(newsub);
                }
            });
            setFieldOptions({...FieldOptions, ...{ref_program: SubOptions}});
            //We also need to reset the Conditional 2;
            setFormValues({...UpdatedFormValues, ...{ref_program: null}});
        }
        if (field === "ref_program") {
            //We update the Options of the ConditionalSelect3
            let SubOptions = [];
            FieldSubOptionsFull.ref_program.forEach((elem) => {
                if (elem.ref_program === SelectedValues) {
                    let newsub = {value: elem.id, label: elem.milestone_name};
                    SubOptions.push(newsub);
                }
            });
            setFieldOptions({...FieldOptions, ...{ref_milestone: SubOptions}});
            //We also need to reset the Conditional 3;
            setFormValues({...UpdatedFormValues, ...{ref_milestone: null}});
        }
    };
    /**************** HANDLING SELECT CHANGE - INCLUDING SUB-SELECT *****************/

    /**************** HANDLING ALL INPUT CHANGES EXCEPTED SELECT  *****************/

    const HandleUpdateFormValues = (field, values) => {
        let value = values.Value;
        let formattedValue = values.FormattedValue;
        let FieldPristine = values.Pristine;

        //Checking Pristine

        // Update the pristine based on the Field
        var FinalPristine = true;
        let PristineKeys = _.keys(PristineDetails);
        let UpdatedPristineDetails = PristineDetails;

        if (PristineKeys && PristineKeys.length > 0) {
            //Going through all the pristine fields to check if one of them is false
            var CurrentFieldHandled = false;
            PristineKeys.forEach((key) => {
                if (key === field) {
                    CurrentFieldHandled = true;
                    //Update the pristine value
                    UpdatedPristineDetails[field] = FieldPristine;
                    if (FieldPristine === false) {
                        FinalPristine = false;
                    }
                } else {
                    //just checking if false;
                    if (UpdatedPristineDetails[key] === false) {
                        FinalPristine = false;
                    }
                }
            });
            if (CurrentFieldHandled === false) {
                //The key wasn't there so we need to add it
                if (FieldPristine === false) {
                    UpdatedPristineDetails = {...UpdatedPristineDetails, ...{[field]: false}};
                    FinalPristine = false;
                }
            }
        } else {
            //First field to be touched
            if (FieldPristine === false) {
                UpdatedPristineDetails = {...UpdatedPristineDetails, ...{[field]: false}};
                FinalPristine = false;
            }
        }
        var UpdateFormValues = {[field]: value};

        //Conditional Fields
        if (field === "is_personal") {
            if (value === true) {
                //we need to reset the date of the Completion Date
                UpdateFormValues.is_billable = false;
            }
        }

        setPristineDetails(UpdatedPristineDetails);
        setFormValues({...FormValues, ...UpdateFormValues});
        setPristine(FinalPristine);

        //Manual update the pristine
        /************* DONT MODIFY THIS LOGIC OR THE PRISTINE AND INVALID WILL BE LOST *****************/
        // let FormValuesKeys = _.keys(FormValues);
        // var FinalPristine = true;

        // if (FormValuesKeys && FormValuesKeys.length > 0) {
        //     FormValuesKeys.forEach((key) => {
        //         let InitialValue = InitialFormValues[key];

        //         var Value;
        //         if (key !== field) {
        //             Value = FormValues[key];
        //         } else {
        //             //Check that the modified field is not the same as the InitalValue (The value has not changed yet)
        //             Value = value;
        //         }
        //         if (InitialValue === undefined) {
        //             InitialValue = null; //We set it to null to be able to compare to the Input Value that is set to null
        //             //It means that there was no initialValue passed to the form (that's the case when it is new)
        //         }
        //         if (InitialValue !== Value) {
        //             FinalPristine = false;
        //         }
        //     });
        // }

        /************* DONT MODIFY THIS LOGIC OR THE PRISTINE AND INVALID WILL BE LOST *****************/

        //Confirm Errors
        ValidateForm(field, value);
        HandleFiedsChange(field, value);
    };

    const HandleUpdateErrors = (field, error) => {
        // console.log("HandleUpdateErrors", field, error);
        //We need to check if there is an error or not
        const ErrorsKeys = _.keys(FormErrors);
        var FinalErrors = {};
        var InvalidTemp = false;
        if (ErrorsKeys && ErrorsKeys.length > 0) {
            // If there is an error
            ErrorsKeys.forEach((key) => {
                if (key !== field) {
                    if (FormErrors[key]) {
                        //Add the error in the list
                        FinalErrors = {...FinalErrors, ...{[key]: FormErrors[key]}};
                        InvalidTemp = true;
                    }
                }
            });
        }

        if (error) {
            //Add the error in the list
            FinalErrors = {...FinalErrors, ...{[field]: error}};
            InvalidTemp = true;
        }
        // console.log("InfalErrors", FinalErrors);

        setFormErrors(FinalErrors);

        setInvalid(InvalidTemp);
    };

    /**************** HANDLING ALL INPUT CHANGES EXCEPTED SELECT  *****************/

    /**************** UPDATE THE OPTIONS WITH THE CREATED ONES IF ANY (DONT NEED TO BE UPDATED NORMALLY) *****************/
    //Update the Select Creatable Options to add the new Options to the menu and transfer the new Options to the parent component
    const UpdateCreatableOptions = (field, UpdatedOptions) => {
        let FullNewOptions = UpdatedOptions.FullOptions;
        let NewOptions = UpdatedOptions.NewOptions;

        FieldOptions[field] = FullNewOptions;
        setNewFieldOptions({...NewFieldOptions, ...{[field]: NewOptions}});
        setFieldOptions(FieldOptions);
    };
    /**************** UPDATE THE OPTIONS WITH THE CREATED ONES IF ANY (DONT NEED TO BE UPDATED NORMALLY) *****************/

    /**************** UPDATE THE FilesUploaders IF ANY (DONT NEED TO BE UPDATED NORMALLY) *****************/
    //UPDATE THE UPLOADED FILES FIELDS IF ANY
    const UpdateFormFiles = (filesPath, fieldName) => {
        if (fieldName) {
            FilesUploaders[fieldName] = filesPath;
            setFilesUploaders(FilesUploaders);
        }
    };
    /**************** UPDATE THE FilesUploaders IF ANY (DONT NEED TO BE UPDATED NORMALLY) *****************/

    /**************** FORM SUBMISSION (DONT NEED TO BE UPDATED NORMALLY) *****************/

    const HandleSubmitForm = (submitType) => {
        /**Default SubmitType :
         * SaveDraft,
         * SaveAndQuit
         * QuitNoSave
         * reset //No Caps
         * Publish
         * Delete
         * NextSave
         * NextQuit
         * PreviousSave
         * PreviousQuit
         */
        if (submitType === "reset") {
            //Reinitializing the select options in case some were created
            let LoadData = JSON.parse(JSON.stringify(FormData.SelectOptions));
            setFieldOptions(LoadData);
            //Reinitializing the pristineDetails
            setPristineDetails({});
            //Reinitializing the CreatedOptions
            setNewFieldOptions({});

            //Reinitializing the FilesUplaoders
            let filesinit = JSON.parse(JSON.stringify(FormData.FilesUploaders));
            setFilesUploaders(filesinit);

            //Reinitializing the FormValues;

            setFormValues(InitialFormValues);

            //Reinitializing the Errors;

            setFormErrors(InitialFormErrors);

            //Setting the Form back to pristine
            setPristine(true);
        }
        if (typeof OnSubmitExternal === "function") {
            //If there are new created options, we need to pass them too with the value

            //WE ONLY PASS THE FORMVALUES THAT ARE DIFFERENT THAN THE INITALVALUES
            var FinalSubmittedValues = {};
            let FormValuesKeys = _.keys(FormValues);

            if (FormValuesKeys && FormValuesKeys.length > 0) {
                FormValuesKeys.forEach((key) => {
                    if (key === "ApiID") {
                        FinalSubmittedValues = {...FinalSubmittedValues, ...{[key]: FormValues[key]}};
                    }
                    //Get the IntialValue
                    let InitialValue = InitialFormValues[key];
                    let Value = FormValues[key];
                    // console.log("key", key);
                    // console.log("InitialValue", InitialValue);
                    // console.log("Value", Value);

                    if (InitialValue !== Value) {
                        FinalSubmittedValues = {...FinalSubmittedValues, ...{[key]: FormValues[key]}};
                    }
                });
            }

            let FullSubmission = {
                typeOfSubmit: submitType, //Just passing the reset in case the parent needs to know
                values: FinalSubmittedValues ? FinalSubmittedValues : null,
            };
            //Prevent passing new created options if there are no new options

            if (_.isEmpty(NewFieldOptions) === false) {
                FullSubmission.NewCreatedOptions = NewFieldOptions;
            }

            //Submitting
            OnSubmitExternal(FullSubmission);

            //Updating the form state for editing after it has been submitted to define the editing mode
            if (OpenInViewMode === true) {
                if (SwitchEditMode === "EditButton") {
                    setFormViewMode("EditButton");
                }
                if (SwitchEditMode === "FieldClick") {
                    setFormViewMode("FieldClick");
                } else {
                    setFormViewMode("View");
                }
            }
        } else {
            console.log("You didn't pass a function for an external submission");
        }
    };
    /**************** FORM SUBMISSION (DONT NEED TO BE UPDATED NORMALLY) *****************/

    /****************************************************************** EDITABLE SECTION ******************************************************************/

    /**************** FORM VALIDATION  *****************/
    const ValidateForm = (field, value) => {
        var UpdatedFormErrors = {...FormErrors};

        // if (field === "testval") {
        //     if (value) {
        //         if (value === "Caca") {
        //             UpdatedFormErrors.testval = "Caca is not allowed";
        //         }
        //     } else {
        //         UpdatedFormErrors.testval = "Cannot be empty";
        //     }
        // }

        // if (Object.keys(UpdatedFormErrors).length > 0) {
        //     setFormErrors(UpdatedFormErrors);
        //     setInvalid(true);
        // } else {
        //     setFormErrors({});
        //     setInvalid(false);
        // }
    };
    /**************** FORM VALIDATION  *****************/

    /**************** ON CHANGE UPDATES  *****************/

    const HandleFiedsChange = (field, value) => {
        // if (field === "isSubsidiary") {
        //     if (value === false) {
        //         setFormValues({...FormValues, ...{ref_group: null, isSubsidiary: false}});
        //     } else {
        //         setFormValues({...FormValues, ...{[field]: value}});
        //     }
        // }
    };

    /**************** ON CHANGE UPDATES  *****************/

    /**************** CUSTOM FUNCTIONS  *****************/
    const HandleEnableEditMode = () => {
        setFormViewMode("Edit");
    };

    /**************** CUSTOM FUNCTIONS  *****************/

    /****************************************************************** EDITABLE SECTION ******************************************************************/

    var FinalFormComponent;
    if (FormDataInitReady === true) {
        FinalFormComponent = (
            <div className={classes.FormWrapper}>
                <h1 style={{margin: "0 auto"}}>{FormValues.ApiID === "new" ? "New time entry" : FormValues.ApiID === "newandtrack" ? "New quick track entry" : "Time Entry"}</h1>
                <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                    <FormCompontent
                        Name="entry_name"
                        InitialValue={InitialFormValues.entry_name ? InitialFormValues.entry_name : null}
                        FormValue={FormValues.entry_name ? FormValues.entry_name : null}
                        OutputValue={(values) => HandleUpdateFormValues("entry_name", values)}
                        Component="Input"
                        Variant="Outlined"
                        Label="Entry name"
                        NoMessage={false}
                        meta={{error: FormErrors.entry_name, invalid: FormErrors.entry_name ? true : false}}
                        OutputError={(error) => HandleUpdateErrors("entry_name", error)}
                        // LegendOffsetHeight="0"
                        // LegendOffsetWidth="0"
                        LabelMaxWidth="200px"
                        LabelAlign="Left"
                        Required={true}
                    />
                </div>
                <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                    <FormCompontent
                        Name="entry_details"
                        InitialValue={InitialFormValues.entry_details ? InitialFormValues.entry_details : null}
                        FormValue={FormValues.entry_details ? FormValues.entry_details : null}
                        OutputValue={(values) => HandleUpdateFormValues("entry_details", values)}
                        Component="Input"
                        Variant="Outlined"
                        Label="Details"
                        NoMessage={false}
                        meta={{error: FormErrors.entry_details, invalid: FormErrors.entry_details ? true : false}}
                        OutputError={(error) => HandleUpdateErrors("entry_details", error)}
                        // LegendOffsetHeight="0"
                        // LegendOffsetWidth="0"
                        LabelMaxWidth="200px"
                        multiline={true}
                        RowsToDisplay="3"
                        MaxRows="3"
                        LabelAlign="Left"
                        Required={false}
                    />
                </div>

                <div className={classes.FormMultilineFlex} style={{flex: "1 1 auto"}}>
                    <div className={classes.FormFieldCheckBoxAligned} style={{flex: "1 1 auto"}}>
                        <CheckBox
                            Inputname="is_personal"
                            label="Personal entry"
                            initialvalue={InitialFormValues.is_personal === true ? true : false}
                            curvalue={FormValues.is_personal}
                            ShareInputValue={(value) => HandleUpdateFormValues("is_personal", value)}
                        />
                    </div>
                    <div className={classes.FormFieldCheckBoxAligned} style={{flex: "1 1 auto", display: `${FormValues.is_personal === true ? "none" : "flex"}`}}>
                        <CheckBox
                            Inputname="is_billable"
                            label="Billable entry"
                            initialvalue={InitialFormValues.is_billable === true ? true : false}
                            curvalue={FormValues.is_billable}
                            ShareInputValue={(value) => HandleUpdateFormValues("is_billable", value)}
                        />
                    </div>
                </div>
                <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                    <FormCompontent
                        Name="ref_company"
                        InitialValue={InitialFormValues.ref_company ? InitialFormValues.ref_company : null}
                        FormValue={FormValues.ref_company ? FormValues.ref_company : null}
                        OutputSelectedValues={(values) => handleSelectChange("ref_company", values)}
                        SelectOptions={FieldOptions.ref_company}
                        Component="Select"
                        Variant="Outlined"
                        Label="Company"
                        NoMessage={false}
                        meta={{error: FormErrors.ref_company, invalid: FormErrors.ref_company ? true : false}}
                        OutputError={(error) => HandleUpdateErrors("ref_company", error)}
                        MultiSelect={false}
                        SortSelectOptions="Asc"
                        // SortIcons={true}
                        AllowCreateOption={false}
                        LabelMaxWidth="200px"
                        LabelAlign="Left"
                    />
                </div>
                <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                    <FormCompontent
                        Name="ref_program"
                        InitialValue={InitialFormValues.ref_program ? InitialFormValues.ref_program : null}
                        FormValue={FormValues.ref_program ? FormValues.ref_program : null}
                        OutputSelectedValues={(values) => handleSelectChange("ref_program", values)}
                        SelectOptions={FieldOptions.ref_program}
                        Component="Select"
                        Variant="Outlined"
                        Label="Program"
                        NoMessage={false}
                        MultiSelect={false}
                        SortSelectOptions="Asc"
                        // SortIcons={true}
                        AllowCreateOption={false}
                        LabelMaxWidth="200px"
                        LabelAlign="Left"
                    />
                </div>
                <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                    <FormCompontent
                        Name="ref_milestone"
                        InitialValue={InitialFormValues.ref_milestone ? InitialFormValues.ref_milestone : null}
                        FormValue={FormValues.ref_milestone ? FormValues.ref_milestone : null}
                        OutputSelectedValues={(values) => handleSelectChange("ref_milestone", values)}
                        SelectOptions={FieldOptions.ref_milestone}
                        Component="Select"
                        Variant="Outlined"
                        Label="Milestone"
                        NoMessage={false}
                        MultiSelect={false}
                        SortSelectOptions="Asc"
                        // SortIcons={true}
                        AllowCreateOption={false}
                        LabelMaxWidth="200px"
                        LabelAlign="Left"
                    />
                </div>

                <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                    <FormCompontent
                        Name="ref_taskCategory"
                        InitialValue={InitialFormValues.ref_taskCategory ? InitialFormValues.ref_taskCategory : null}
                        FormValue={FormValues.ref_taskCategory ? FormValues.ref_taskCategory : null}
                        OutputSelectedValues={(values) => handleSelectChange("ref_taskCategory", values)}
                        SelectOptions={FieldOptions.ref_taskCategory}
                        Component="Select"
                        Variant="Outlined"
                        Label="Category"
                        NoMessage={false}
                        meta={{error: FormErrors.ref_taskCategory, invalid: FormErrors.ref_taskCategory ? true : false}}
                        OutputError={(error) => HandleUpdateErrors("ref_taskCategory", error)}
                        MultiSelect={false}
                        SortSelectOptions="Asc"
                        // SortIcons={true}
                        AllowCreateOption={true}
                        // CreateDeleteIfUnselected={}
                        UpdateCreatableOptions={(options) => UpdateCreatableOptions("ref_taskCategory", options)}
                        LabelMaxWidth="200px"
                        LabelAlign="Left"
                    />
                </div>
                <div className={classes.FormField} style={{flex: "1 1 auto", display: `${FormValues.ApiID !== "new" ? (InitialFormValues.estimated_duration_seconds ? "flex" : "none") : "none"}`}}>
                    <FormCompontent
                        Name="estimated_duration_seconds"
                        InitialValue={InitialFormValues.estimated_duration_seconds ? InitialFormValues.estimated_duration_seconds : null}
                        FormValue={FormValues.estimated_duration_seconds ? FormValues.estimated_duration_seconds : null}
                        OutputValue={(values) => HandleUpdateFormValues("estimated_duration_seconds", values)}
                        Component="DatePicker"
                        Variant="Outlined"
                        Label="Estimated duration"
                        NoMessage={false}
                        // meta={{error: FormErrors.date_calendarNokeyboard, invalid: FormErrors.date_calendarNokeyboard ? true : false}}
                        // OutputError={(error) => HandleUpdateErrors("date_calendarNokeyboard", error)}
                        // LegendOffsetHeight="0"
                        // LegendOffsetWidth="0"
                        PickerDateType="TimeHM"
                        PickerOnly={false}
                        InputFormat="HH:mm"
                        CalendarOptions={{
                            TodayButton: false,
                        }}
                        RollerOptions={{
                            MinuteInterval: 5,
                            SecondInterval: 30,
                        }}
                        LabelMaxWidth="200px"
                        LabelAlign="Left"
                    />
                </div>
                <div className={classes.FormField} style={{flex: "1 1 auto", display: `${FormValues.ApiID === "newandtrack" ? "none" : "flex"}`}}>
                    <FormCompontent
                        Name="date_Iso"
                        InitialValue={InitialFormValues.date_Iso ? InitialFormValues.date_Iso : null}
                        FormValue={FormValues.date_Iso ? FormValues.date_Iso : null}
                        OutputValue={(values) => HandleUpdateFormValues("date_Iso", values)}
                        Component="DatePicker"
                        Variant="Outlined"
                        Label="Entry Date"
                        NoMessage={false}
                        PickerDateType="Calendar"
                        PickerOnly={false}
                        InputFormat="yyyy/MM/dd"
                        LabelMaxWidth="200px"
                        LabelAlign="Left"
                    />
                </div>
                <div className={classes.FormField} style={{flex: "1 1 auto", display: `${FormValues.ApiID === "newandtrack" ? "none" : "flex"}`}}>
                    <FormCompontent
                        Name="start_time"
                        InitialValue={InitialFormValues.start_time ? InitialFormValues.start_time : null}
                        FormValue={FormValues.start_time ? FormValues.start_time : null}
                        OutputValue={(values) => HandleUpdateFormValues("start_time", values)}
                        Component="DatePicker"
                        Variant="Outlined"
                        Label="Start time"
                        NoMessage={false}
                        // meta={{error: FormErrors.date_calendarNokeyboard, invalid: FormErrors.date_calendarNokeyboard ? true : false}}
                        // OutputError={(error) => HandleUpdateErrors("date_calendarNokeyboard", error)}
                        // LegendOffsetHeight="0"
                        // LegendOffsetWidth="0"
                        PickerDateType="TimeHM"
                        PickerOnly={false}
                        InputFormat="HH:mm"
                        CalendarOptions={{
                            TodayButton: false,
                        }}
                        RollerOptions={{
                            MinuteInterval: 5,
                            SecondInterval: 30,
                        }}
                        LabelMaxWidth="200px"
                        LabelAlign="Left"
                    />
                </div>
                <div className={classes.FormField} style={{flex: "1 1 auto", display: `${FormValues.ApiID === "newandtrack" ? "none" : "flex"}`}}>
                    <FormCompontent
                        Name="end_time"
                        InitialValue={InitialFormValues.end_time ? InitialFormValues.end_time : null}
                        FormValue={FormValues.end_time ? FormValues.end_time : null}
                        OutputValue={(values) => HandleUpdateFormValues("end_time", values)}
                        Component="DatePicker"
                        Variant="Outlined"
                        Label="End time"
                        NoMessage={false}
                        // meta={{error: FormErrors.date_calendarNokeyboard, invalid: FormErrors.date_calendarNokeyboard ? true : false}}
                        // OutputError={(error) => HandleUpdateErrors("date_calendarNokeyboard", error)}
                        // LegendOffsetHeight="0"
                        // LegendOffsetWidth="0"
                        PickerDateType="TimeHM"
                        PickerOnly={false}
                        InputFormat="HH:mm"
                        CalendarOptions={{
                            TodayButton: false,
                        }}
                        RollerOptions={{
                            MinuteInterval: 5,
                            SecondInterval: 30,
                        }}
                        LabelMaxWidth="200px"
                        LabelAlign="Left"
                    />
                </div>
                <div className={classes.FormField} style={{flex: "1 1 auto", display: `${FormValues.ApiID == "new" || FormValues.ApiID == "newandtrack" ? "none" : "flex"}`}}>
                    <FormCompontent
                        Name="duration_seconds"
                        InitialValue={InitialFormValues.duration_seconds ? InitialFormValues.duration_seconds : null}
                        FormValue={FormValues.duration_seconds ? FormValues.duration_seconds : null}
                        OutputValue={(values) => HandleUpdateFormValues("duration_seconds", values)}
                        Component="Input"
                        Variant="Outlined"
                        NoMessage={true}
                        Label="Duration"
                        LabelMaxWidth="200px"
                        LabelAlign="Left"
                        ReadOnly={true}
                    />
                </div>

                <FormDev
                    DevMode={DevMode}
                    FormValues={FormValues}
                    InitialFormValues={InitialFormValues}
                    FieldOptions={FieldOptions}
                    FieldSubOptionsFull={FieldSubOptionsFull}
                    FilesUploaders={FilesUploaders}
                    FormErrors={FormErrors}
                    NewFieldOptions={NewFieldOptions}
                    PristineDetails={PristineDetails}
                />
                {/* Button Bar */}
                <div className={classes.FormErrorMainMessage} style={{display: FormErrorMain ? null : "none"}}>
                    {`${FormErrorMain ? FormErrorMain : null}`}
                </div>
                <div style={{height: "80px"}}>
                    <FormSubmitButtons
                        ButtonSaveAsDraft={ButtonSaveAsDraft}
                        ButtonSaveAndQuit={ButtonSaveAndQuit}
                        ButtonQuitNoSave={ButtonQuitNoSave}
                        ButtonDelete={ButtonDelete}
                        ButtonPublish={ButtonPublish}
                        ButtonReset={ButtonReset}
                        ButtonNext={ButtonNext}
                        ButtonPrevious={ButtonPrevious}
                        HandleSubmitForm={HandleSubmitForm}
                        Invalid={Invalid}
                        Pristine={Pristine}
                        DisableToolTip={DisableToolTip}
                        FormViewMode={FormViewMode}
                    />
                </div>

                {/* Button Bar */}
            </div>
        );
    } else {
        FinalFormComponent = null;
    }
    return <div className={classes.FormWrapper}>{FinalFormComponent}</div>;
});
export default Component;
